import styled, { css, keyframes } from 'styled-components';
import { palette } from '../../theme/colors';

const bubbleEntrance = keyframes`
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const SBubbleWrapper = styled.div<{ isDanger: boolean; $animate: boolean }>`
  position: absolute;
  top: 0;
  left: 70%;
  z-index: 98;
  height: 1rem;
  font-size: 0.75rem;
  padding: 0 0.31rem;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, isDanger }) =>
    isDanger ? theme.palette.background.danger : theme.palette.background.bubble};
  ${({ $animate }) =>
    $animate &&
    css`
      animation: ${bubbleEntrance} 400ms cubic-bezier(0.34, 1.56, 0.64, 1) 150ms both;
    `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  &.footerNotificationBubble {
    left: 58%;
    color: ${palette.white};
  }
`;

export const SBubbleText = styled.p`
  font-family: 'Roboto-Regular';
  font-size: 1em;
  line-height: 1;
  margin: 0;
  text-align: center;
  color: ${palette.white};
`;

export const SBubbleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.93em;
  height: 0.93em;
  color: ${palette.white};

  svg {
    width: 100%;
    height: 100%;
  }
`;
